/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { customInstance } from '../../../../mutator/instance';
import type { DepositLimitResponse } from '../../models';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export const getDepositCapacity = (
  productUid: string,
  signal?: AbortSignal
) => {
  return customInstance<DepositLimitResponse>({
    url: `/operations/products/deposit-capacity/${productUid}`,
    method: 'GET',
    signal,
  });
};

export const getGetDepositCapacityQueryKey = (productUid: string) => {
  return [`/operations/products/deposit-capacity/${productUid}`] as const;
};

export const getGetDepositCapacityQueryOptions = <
  TData = Awaited<ReturnType<typeof getDepositCapacity>>,
  TError = unknown
>(
  productUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDepositCapacity>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDepositCapacityQueryKey(productUid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepositCapacity>>> =
    ({ signal }) => getDepositCapacity(productUid, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!productUid,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDepositCapacity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDepositCapacityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDepositCapacity>>
>;
export type GetDepositCapacityQueryError = unknown;

export const useGetDepositCapacity = <
  TData = Awaited<ReturnType<typeof getDepositCapacity>>,
  TError = unknown
>(
  productUid: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getDepositCapacity>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDepositCapacityQueryOptions(productUid, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
